// extracted by mini-css-extract-plugin
export var measureBox = "_bw-0";